import { Alert, Fade, Grid } from '@mui/material';
import { isEmpty } from 'lodash';
import moment from 'moment/moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderPageTypography } from '../../../themedComponents/OrderPageTypography';
import { TimeSlotResponseOut } from '../../../../api';
import { getOrderPage } from '../../../../utils/AccountUtils';
import { useLanguage } from '../../../../utils/GeneralUtils';
import { useOrderPage } from '../../../orderPageContext/useOrderPage';

type TroubleshootProps = {
  timeSlotResponseOut?: TimeSlotResponseOut;
};

export const Troubleshoot = ({ timeSlotResponseOut }: TroubleshootProps) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const { orderPageState } = useOrderPage();
  if (!timeSlotResponseOut) {
    return null;
  }
  return (
    <Fade in timeout={1000}>
      <Alert sx={{ marginTop: '16px' }} severity="warning">
        <Grid container flexDirection="column">
          <OrderPageTypography color="warning">
            {t(`troubleshoot.${timeSlotResponseOut.timeDisableReason}`)}
          </OrderPageTypography>
          {timeSlotResponseOut.timeDisabledDetails?.time && (
            <Grid container gap={1}>
              <OrderPageTypography color="warning">{t(`troubleshoot.problematicTime`)}</OrderPageTypography>
              <OrderPageTypography color="warning">
                {moment.unix(timeSlotResponseOut.timeDisabledDetails?.time).utc().format('HH:mm')}
              </OrderPageTypography>
            </Grid>
          )}
          {!isEmpty(timeSlotResponseOut.timeDisabledDetails?.orderNumbers) && (
            <Grid container gap={1}>
              <OrderPageTypography color="warning">{t(`troubleshoot.orderNumbers`)}</OrderPageTypography>
              {timeSlotResponseOut.timeDisabledDetails?.orderNumbers?.map((x: number) => (
                <OrderPageTypography color="warning">{x}</OrderPageTypography>
              ))}
            </Grid>
          )}
          {!isEmpty(timeSlotResponseOut.timeDisabledDetails?.orderPageIds) && (
            <Grid container gap={1}>
              <OrderPageTypography color="warning">{t(`troubleshoot.orderPages`)}</OrderPageTypography>
              {timeSlotResponseOut.timeDisabledDetails?.orderPageIds?.map((orderPageId: string) => (
                <OrderPageTypography key={orderPageId} color="warning">
                  {getOrderPage(orderPageState.account, orderPageId)?.label[language] ?? orderPageId}
                </OrderPageTypography>
              ))}
            </Grid>
          )}
          {!isEmpty(timeSlotResponseOut.timeDisabledDetails?.eventIds) && (
            <Grid container gap={1}>
              <OrderPageTypography color="warning">{t(`troubleshoot.eventIds`)}</OrderPageTypography>
              {timeSlotResponseOut.timeDisabledDetails?.eventIds?.map((x: string) => (
                <OrderPageTypography color="warning">{x}</OrderPageTypography>
              ))}
            </Grid>
          )}
          {!isEmpty(timeSlotResponseOut.timeDisabledDetails?.unavailabilityStartTimes) && (
            <Grid container gap={1}>
              <OrderPageTypography color="warning">{t(`troubleshoot.unavailabilityStartTime`)}</OrderPageTypography>
              {timeSlotResponseOut.timeDisabledDetails?.unavailabilityStartTimes?.map((x: number) => (
                <OrderPageTypography color="warning">
                  {x === 0 ? t('calendar.unavailability_dialog.all_day') : moment.unix(x).utc().format('HH:mm')}
                </OrderPageTypography>
              ))}
            </Grid>
          )}
        </Grid>
      </Alert>
    </Fade>
  );
};
